var prodSubscriptionPlans = [{
  name: 'Starter Package - Annual',
  price: '$690',
  id: 'price_1L5zq6Ch4NtuacNGlgDNxXd0'
}, {
  name: 'Starter Package - Monthly',
  price: '$69',
  id: 'price_1L5zq6Ch4NtuacNGtKTyZwis'
}, {
  name: 'Standard Package - Annual',
  price: '$990',
  id: 'price_1L5zq6Ch4NtuacNG0wByYXCY'
}, {
  name: 'Standard Package - Monthly',
  price: '$99',
  id: 'price_1L5zq6Ch4NtuacNGi8D4NTVD'
}, {
  name: 'Premium Package - Annual',
  price: '$1,290',
  id: 'price_1L5zq5Ch4NtuacNGehBnJqth'
}, {
  name: 'Premium Package - Monthly',
  price: '$129',
  id: 'price_1L5zq5Ch4NtuacNG8obo2OZI'
}];
var testSubscriptionPlans = [{
  name: 'Starter Package - Annual',
  price: '$690',
  id: 'price_1L4AxsCh4NtuacNGYM7vTAuS'
}, {
  name: 'Starter Package - Monthly',
  price: '$69',
  id: 'price_1L4AxsCh4NtuacNGC4h9FAJR'
}, {
  name: 'Standard Package - Annual',
  price: '$990',
  id: 'price_1L4AxsCh4NtuacNGIjSF6cMT'
}, {
  name: 'Standard Package - Monthly',
  price: '$99',
  id: 'price_1L4AxsCh4NtuacNGR2YJrgxP'
}, {
  name: 'Premium Package - Annual',
  price: '$1,290',
  id: 'price_1L4AxsCh4NtuacNG9Xcu1qP4'
}, {
  name: 'Premium Package - Monthly',
  price: '$129',
  id: 'price_1L4AxsCh4NtuacNGxezvFDlU'
}];
var planMode = process.env.STRIPE_PLAN_MODE || process.env.STORYBOOK_STRIPE_PLAN_MODE;
var subscriptionPlans = planMode === 'test' ? testSubscriptionPlans : prodSubscriptionPlans;
export default subscriptionPlans;